class DynamicLinkListPageController {

  constructor(DynamicLinkService, AlertService, LoaderService) {
    this.AlertService = AlertService;
    this.DynamicLinkService = DynamicLinkService;
    this.LoaderService = LoaderService;
  }

  $onInit() {
    var self = this;
    self.getFromServer();
  }

  clearFilter() {
    var self = this;
    self.filtered = false;
    self.getFromServer();
  }

  getFromServer() {
    var self = this;
    self.LoaderService.start();
    self.DynamicLinkService.get()
        .then( (dynamicLinks) => self.dynamicLinks = dynamicLinks)
        .catch( (error) => self.AlertService.error("There was a problem getting the dynamic links"))
        .finally( ()=> self.LoaderService.stop() );
  }

}
DynamicLinkListPageController.$inject = ['DynamicLinkService', 'AlertService', 'LoaderService'];
export default DynamicLinkListPageController;
